module.exports = __webpack_public_path__ + "static/media/favorite-mobile-icon.505c10ef.svg";